import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'default' | 'large';
  variant?: 'lime' | 'navy';
  className?: string;
}
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'default',
  variant = 'lime',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-9 py-5 text-[15px]' : 'px-7 py-4 text-[13px] sm:text-sm';
  const variants = {
    lime: 'bg-lime text-ink hover:bg-lime-ink hover:text-shell shadow-[0_18px_36px_-20px_rgba(198,240,36,0.95)] focus-visible:outline-lime-ink',
    navy: 'bg-navy text-shell hover:bg-ink shadow-[0_18px_36px_-20px_rgba(18,50,98,0.9)] focus-visible:outline-navy'
  };
  const isCheckout = href === checkoutUrl;
  const handleClick = () => {
    trackPixelEvent(isCheckout ? 'InitiateCheckout' : 'ViewContent', {
      content_name: 'The Pickleball Instructor’s Vault',
      value: 27,
      currency: 'USD'
    });
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded-full font-display font-bold uppercase tracking-[0.08em] transition-[background-color,color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${variants[variant]} ${sizing} ${className}`} data-id="element-46" data-mp="39yhm9keivbao">
      <span data-id="element-47" data-mp="3swtxdbozuv8w">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={2.4} aria-hidden="true" data-id="element-48" data-mp="3sw2g75w59025" />
    </a>;
}